<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="reset" icon="el-icon-plus" style="float: right;margin-right: 10px;">重置属性</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '重命名'>
      </el-table-column>
      <el-table-column
        prop= 'isHide'
        label= '隐藏'>
        <template slot-scope='scope'>
          <el-button type='info' size='small' v-if="scope.row.isHide===1">隐藏</el-button>
          <el-button type='success' size='small' v-if="scope.row.isHide===0">显示</el-button>
        </template>
      </el-table-column>      
      <el-table-column
        prop= 'addr'
        label= '属性地址(十进制)'>
      </el-table-column>
      <el-table-column
        prop= 'loraAddr'
        label= 'lora地址(十进制)'>
      </el-table-column>
      <el-table-column
        prop= 'minControlTime'
        label= '最小控制时间'>
      </el-table-column>
      <el-table-column
        prop= 'queryTime'
        label= '查询时间'>
      </el-table-column>
      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '160'>
        <template slot-scope='scope'>
          <el-button @click='coverHide(scope.row)' type='text' size='small' style="color: #209323">{{ scope.row.isHide!=1?'隐藏':"显示" }}</el-button>
          <el-button @click='edit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" :modal="false">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="重命名" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="485地址(十进制)" :label-width="formLabelWidth" prop="addr">
          <el-input v-model="form.addr" autocomplete="off" placeholder="485地址"></el-input>
        </el-form-item>
        <el-form-item label="是否隐藏" :label-width="formLabelWidth" prop="isHide">
              <el-radio v-model="form.isHide" :label=1>是</el-radio>
              <el-radio v-model="form.isHide" :label=0>否</el-radio>
            </el-form-item>
        <el-form-item label="lora地址(十进制)" :label-width="formLabelWidth" prop="loraAddr">
          <el-input v-model="form.loraAddr" autocomplete="off" placeholder="如果是无线lora则填写该地址"></el-input>
        </el-form-item>
        <el-form-item label="最小控制时间" :label-width="formLabelWidth" prop="minControlTime">
          <el-input v-model="form.minControlTime" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="查询时间" :label-width="formLabelWidth" prop="queryTime">
          <el-input v-model="form.queryTime" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  props: {
    deviceInstantiationId: {
      type: Number,
      default: 0,
      required: false
    }
  },
  watch: {
    deviceInstantiationId: {
      handler (newV, oldV) {
        this.deviceInstantiationId = newV
        this.form.deviceInstantiationId = this.deviceInstantiationId
        this.query()
      },
      immediate: true
    }
  },  
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        deviceModelId: null,
        deviceModelPropertyId: null,
        deviceInstantiationId: null,
        name: null,
        addr: null,
        loraAddr: null,
        minControlTime: null,
        queryTime: null,
        isHide: null
      },
      rules: {
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      deviceInstantiationId: null
    }
  },
  created () {
    this.query()
  },
  methods: {
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/deviceInstantiationUserProperty/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/deviceInstantiationUserProperty/listPage?current=${that.current}&pageSize=${that.pageSize}&deviceInstantiationId=${that.deviceInstantiationId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    edit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },  
    reset () {
      let that = this
      requestService.post(`/deviceInstantiationUserProperty/reset?deviceInstantiationId=${that.deviceInstantiationId}`, {}, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.query()
      })
    },  
    coverHide (row) {
      let that = this
      let params = {}
      if(row.isHide==1){
        params.isHide = 0
      }else{
        params.isHide = 1
      }
      params.id = row.id
      requestService.post('/deviceInstantiationUserProperty/edit', params, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.query()
      })
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          requestService.post('/deviceInstantiationUserProperty/edit', that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/deviceInstantiationUserProperty/Index.vue